import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardHeader, Col, Table } from 'reactstrap';
import { H5, H6, P, UL, LI, Badges, Image } from '../../../AbstractElements';
import Avatar from '../../../assets/images/dashboard/admins.png';
import { AdministratorTitle, EmayWalter, New, ViewMoreAdminInformation, ViewMoreInformation } from '../../../Constant';

const Administrator = () => {
  return (
    <>
      <Col md='12' sm='6'>
        <Card className='administrator-sec'>
          <CardHeader className='card-no-border pb-0'>
            <H5>{AdministratorTitle}</H5>
            <div className='center-content'>
              <P>{ViewMoreAdminInformation}</P>
            </div>
          </CardHeader>
          <CardBody>
            <div className='administrator-table'>
              <Table responsive className='table-bordernone'>
                <tbody>
                  <tr>
                    <td>
                      <div className='d-flex'>
                        <Image className='img-fluid img-50 rounded-circle' src={Avatar} alt='avatar' />
                        <div className='status-circle bg-primary'> </div>
                        <div className='flex-grow-1'>
                          <Link to={`${process.env.PUBLIC_URL}/user-profile`}>
                            <H6>
                              {EmayWalter}
                              <Badges color='primary' className='ms-4'>
                                {New}
                              </Badges>
                            </H6>
                          </Link>
                          <P>{ViewMoreInformation}</P>
                        </div>
                      </div>
                    </td>
                    <td>
                      <UL horizontal={true}>
                        <LI>
                          <div className='admini-icon'>
                            <i className='fa fa-phone m-0' />
                          </div>
                        </LI>
                        <LI>
                          <div className='admini-icon'>
                            <i className='fa fa-commenting m-0' />
                          </div>
                        </LI>
                      </UL>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

export default Administrator;
